import { useForm } from "@inertiajs/react";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Highlight from "@tiptap/extension-highlight";
import Typography from "@tiptap/extension-typography";

import "./New.scss";
import cs from "./New.module.scss";
import { FormEvent } from "react";

type Props = {
  people: {
    id: string;
    name: string;
  }[];
};

export default function New({ people }: Props) {
  const { data, setData, post, processing, transform } = useForm<{
    body: string;
    person_ids: string[];
  }>({
    body: "",
    person_ids: [],
  });

  function submit(e: FormEvent) {
    e.preventDefault();
    transform((data) => ({
      note: {
        ...data,
      },
    }));
    post("/notes", {
      preserveState: false,
      replace: false,
    });
  }

  const editor = useEditor({
    extensions: [StarterKit, Highlight, Typography],
    content: ``,
    onUpdate: ({ editor }) => {
      const json = editor.getJSON();
      console.log("updating");
      setData({
        ...data,
        body: JSON.stringify(json),
      });
    },
  });

  return (
    <>
      <form onSubmit={submit} data-turbo="false">
        <div className={cs.editorWrapper}>
          <EditorContent className="prose" editor={editor} />
        </div>
        <div>
          <select
            multiple
            value={data.person_ids}
            onChange={(e) => {
              const person_ids = Array.from(e.target.options)
                .filter((option) => option.selected)
                .map((option) => option.value);
              setData({
                ...data,
                person_ids,
              });
            }}
          >
            {people.map((person) => (
              <option value={person.id}>{person.name}</option>
            ))}
          </select>
        </div>
        <button type="submit" disabled={processing}>
          Create
        </button>
      </form>
    </>
  );
}
